const BANKER_STORAGE_KEY = "bankerNumbers";
const BANKER_REFRESH_HOURS = [4, 10, 13];

const createRandomBankerNumbers = () => {
  const numbers = new Set();

  while (numbers.size < 5) {
    numbers.add(Math.floor(Math.random() * 90) + 1);
  }

  return Array.from(numbers);
};

const normalizeBankerNumbers = (value) => {
  if (!Array.isArray(value)) {
    return null;
  }

  const normalized = value
    .map((entry) => Number(entry))
    .filter((entry) => Number.isInteger(entry) && entry >= 1 && entry <= 90)
    .slice(0, 5);

  return normalized.length === 5 ? normalized : null;
};

const getBankerCycleKey = (referenceDate = new Date()) => {
  const current = new Date(referenceDate);
  const cycleDate = new Date(current);
  let cycleIndex = BANKER_REFRESH_HOURS.length - 1;

  for (let index = BANKER_REFRESH_HOURS.length - 1; index >= 0; index -= 1) {
    const refreshTime = new Date(current);
    refreshTime.setHours(BANKER_REFRESH_HOURS[index], 0, 0, 0);

    if (current >= refreshTime) {
      cycleIndex = index;
      break;
    }

    if (index === 0) {
      cycleDate.setDate(cycleDate.getDate() - 1);
      cycleIndex = BANKER_REFRESH_HOURS.length - 1;
    }
  }

  const year = cycleDate.getFullYear();
  const month = String(cycleDate.getMonth() + 1).padStart(2, "0");
  const day = String(cycleDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}-${cycleIndex}`;
};

const readStoredBankerState = () => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const rawValue = window.localStorage.getItem(BANKER_STORAGE_KEY);

    if (!rawValue) {
      return null;
    }

    const parsed = JSON.parse(rawValue);

    if (Array.isArray(parsed)) {
      const normalizedLegacyNumbers = normalizeBankerNumbers(parsed);

      return normalizedLegacyNumbers
        ? { cycleKey: null, numbers: normalizedLegacyNumbers }
        : null;
    }

    const normalizedNumbers = normalizeBankerNumbers(parsed?.numbers);
    if (!normalizedNumbers) {
      return null;
    }

    return {
      cycleKey: typeof parsed.cycleKey === "string" ? parsed.cycleKey : null,
      numbers: normalizedNumbers,
    };
  } catch (error) {
    return null;
  }
};

const writeStoredBankerState = (state) => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(BANKER_STORAGE_KEY, JSON.stringify(state));
};

export const getCurrentBankerNumbers = (referenceDate = new Date()) => {
  const currentCycleKey = getBankerCycleKey(referenceDate);
  const storedState = readStoredBankerState();

  if (storedState?.cycleKey === currentCycleKey && storedState.numbers) {
    return storedState.numbers;
  }

  const nextState = {
    cycleKey: currentCycleKey,
    numbers: createRandomBankerNumbers(),
  };

  writeStoredBankerState(nextState);

  return nextState.numbers;
};